import { gql } from '@apollo/client';

export const SEARCH_TRACKING_RECOMMENDATION_CLICK = gql`
    mutation SearchTrackingRecommendationClick($trackingRecommendationClickPos: TrackingRecommendationClickPos!) {
        searchTrackingRecommendationClick(trackingRecommendationClickPos: $trackingRecommendationClickPos)
    }
`;
